import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import ChatAdminPanel from './ChatAdminPanel';

const AdminChat: React.FC = () => {
  const { user, isAuthenticated } = useAuthStore();

  if (!isAuthenticated || (user?.role !== '管理员' && user?.role !== '站长' && user?.role !== '超级管理员')) {
    return <Navigate to="/" replace />;
  }

  return <ChatAdminPanel />;
};

export default AdminChat;
